
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Sabitle',
	'find_label': 'Bul',
	'findCancelLabel': 'İptal',
	'sourcePaneLabel': 'Seçilen kaynaklar',
	'sourcePaneContentLabel': 'Bir kaynak seç',
	'addDataDashboardCoachMarkContents': 'Veri panosundan gösterge panonuza verileri sürükleyip bırakın.',
	'addDataStoryCoachMarkContents': 'Veri panosundan hikayenize verileri sürükleyip bırakın.',
	'addDataCoachMarkTitle': 'Veri ekle',
	'selectSourcesText': '%{app} uygulamanızı oluşturmak için bir veri kaynağı seçip ekleyin.',
	'selectSourcesLabel': 'Bir kaynak seç',
	'errorSourcesTitle': 'Veri ağacı yüklenemedi',
	'errorLoadingDataSources': 'Veri kümeleri listesi yüklenirken hata oluştu',
	'errorLoadingDataTree': 'Ağaç yüklenirken bir hata oluştu',
	'dataSetPaneLastUpdated': 'Son güncellenme zamanı: %{date}',
	'dataSourcePaneDateUnknown': 'Bilinmiyor',
	'moreTitle': 'Daha Fazla',
	'backLabel': 'Geri git',
	'addDataSourceDialogTitle': 'Veri kaynağı ekle',
	'addDataSourceDialogButtonLabel': 'Ekle',
	'dlg_use': 'Kullan',
	'dlg_RelinkDataSourceTitle': '\'%{dataSourceName}\' veri kümesini şununla değiştir...',
	'propertiesDialogTitle': 'Özellikler',
	'missingDataSetData': 'Bu veri kümesi için veriler kullanılamıyor. Kaynağa erişim için veri kümesini yenileyin veya sistem yöneticinizle görüşün.',
	'errorLoadingSource': '\'%{sourceName}\' için meta veriler yüklenmedi. Lütfen ayrıntılar için sistem yöneticinizle görüşün.',
	'errorMessageTitle': 'Hata',
	'calculation_navigation_in_use': 'Hesaplamalar ya da dolaşma yolları silindiğinde, silinen öğeye başvuran tüm görselleştirmeler geçersiz kılınır. Silmek istediğinizden emin misiniz?',
	'delete_confirm': 'Silmeyi onayla',
	'previewUnavailable': 'Veri tepsisi ve genel süzgeçler bu paket tipi için kullanılamıyor.',
	'contextualGridTabName': 'Görselleştirme verileri',
	'DATA_TRAY_no_data_text': '\'Verileriniz burada görünecektir.\'',
	'contextualGridMenuLabel': 'Görselleştirme verileri menüsü',
	'contextualGridExport': 'Dışa aktar',
	'nullValueText': 'Boş değerli',
	'forecastDetailsTabName': 'İstatistik ayrıntılarını tahmin etme',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Doğruluk Ölçümleri',
	'forecastDetailsSmoothingCoefLabel': 'Parametreler',
	'forecastDetailsDiagnostics': 'Tanılamalar',
	'forecastDetailsForecastLabel': 'Tahmin',
	'forecastDetailsStatusLabel': 'Durum',
	'forecastDetailsAccuracyPercentLabel': 'Doğruluk Yüzdesi',
	'forecastDetailsTrendLabel': 'Eğilim',
	'forecastDetailsSeasonLabel': 'Mevsimsellik',
	'forecastDetailsSeasonalPeriodLabel': 'Mevsimsel dönem',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Fi',
	'forecastDetailsMissingCount': 'Eksik sayı',
	'forecastDetailsSeriesLengthLabel': 'Seri uzunluğu',
	'forecastDetailsIgnoredPeriods': 'Yoksayılan dönemler',
	'forecastDetailsTrendStrength': 'Eğilim gücü',
	'forecastDetailsSeasonalityStrength': 'Mevsimsellik gücü',
	'forecastDetailsTimeDeltaUnit': 'Tarih / saat aralığı',
	'forecastDetailsNotes': 'Notlar'
});
